module.exports = __webpack_public_path__ + "img/headicon.325dc991.png";